import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '@iupics-config/app.config.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CompiereCalloutService {
  private url: string;

  constructor(
    private http: HttpClient,
    private config: AppConfig
  ) {}

  getData(query: string, params: any[], tablenames: string[]): Observable<{}[]> {
    this.url = this.config.getBackendResource('DBSelect');
    return this.http.post<{}[]>(`${this.url}`, {
      query: query,
      params: params,
      tablenames: tablenames,
    });
  }
}
